<template>
    <v-card class="pa-1" flat>
        <v-simple-table fixed-header dense>
            <thead>
                <tr>
                    <template>
                        <th>ユーザーUID</th>
                        <th>ユーザー名</th>
                        <th>登録日</th>
                        <th>バージョン</th>
                        <th></th>
                    </template>
                </tr>
            </thead>
            <tbody>
                <template >
                    <tr v-for="user in users" :key="user.userUID">
                        <td>
                            {{user.userUID}}
                        </td>
                        <td>{{user.userName}}</td>
                        <td>{{user.registeredDateTime}}</td>
                        <td>{{user.systemVersion == null ? 'unknown' : user.systemVersion}}</td>
                        <td>
                            <v-menu offset-y transition="slide-x-transition" position-x="0" close-on-content-click>
                                <template v-slot:activator="{ on }">
                                    <v-btn small icon v-on="on">
                                        <v-icon>mdi-menu</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content @click="onSelectedResetPassword(user)">パスワード変更</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
            </tbody>
        </v-simple-table>
        <v-btn color="primary" @click="onClickMore">more</v-btn>
        <v-dialog v-if="selectedUser != null" v-model="isNewPasswordEdit" persistent width="800" >
            <v-card class="mt-3 pa-1">
                <Title title="パスワード設定">
                    <v-spacer />
                    <TitleButton
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isNewPasswordEdit = false" />
                </Title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col>
                                <h2>{{selectedUser.userName}} 様のパスワードを設定</h2>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field 
                                    v-model="newPassword" 
                                    clearable
                                    hide-details
                                    label="新しいパスワード" 
                                    outlined 
                                    type="text" 
                                    dense />
                            </v-col>
                        </v-row>
                    </v-container>                    
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="onClickExecutePasswordReset">実行(押すと即実行されます)</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Confirm ref="confirm" />
    </v-card>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';

    export default {
        components: {
            Title,
            TitleButton,
            Confirm,
        },
        data: function () {
            return {
                users: [],
                selectedUser: null,
                isNewPasswordEdit: false,
                newPassword: null,
            }
        },
        computed: {
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
        },
        created: function () {
            this.users = []
            const currentDateTime = new Date()
            this.addUsers(currentDateTime.toFormatString("yyyy/MM/dd HH:mm:ss"))
        },
        methods: {
            /**
             * moreボタン押下時
             */
            onClickMore: function () {
                const dateTime = this.users[this.users.length - 1].registeredDateTime
                this.addUsers(dateTime)
            },
            /**
             * パスワードリセット選択時
             */
            onSelectedResetPassword: function (user) {
                this.isNewPasswordEdit = true
                this.selectedUser = user
                this.newPassword = "123456"
            },
            /**
             * パスワード設定の実行ボタン押下時
             */
            onClickExecutePasswordReset: function () {
                // const self = this
                // this.$refs.confirm.show({
                //     title: "パスワード変更",
                //     message: this.selectedUser.userName + " 様のパスワードを設定しても宜しいですか？",
                //     buttonYes: "変更する",
                //     buttonNo: "しない",
                //     listenerYes: function () {
                //         self.resetPassword()
                //         return true
                //     },
                // })
                this.resetPassword()
                this.isNewPasswordEdit = false
            },
            /**
             * パスワードリセット処理
             */
            resetPassword: function () {
                
                const self = this
                
                this.$store.commit("processing", {start:true, message:"パスワードを変更しています…。"})
                
                const reset = new WebSocket("wss://service.tomson.xyz/myfield_password_reset")
                const request = {
                    operator: this.loggedInUserUID,
                    userUID: this.selectedUser.userUID,
                    newPassword: this.newPassword
                }
                reset.onopen = function (e) {
                    console.log("onopen", e)
                    reset.send(
                        JSON.stringify(request)
                    )
                }
                reset.onmessage = function (e) {
                    console.log("onmessage", e.data)
                    self.$store.commit("processing")
                    reset.close()

                    switch (e.data) {
                        case "success":
                            self.$refs.confirm.show({
                                title: "パスワード変更",
                                message: "パスワードが変更されました。",
                                buttonYes: "戻る",
                                buttonNo: "",
                            })
                            return
                            break;
                        default:
                            self.$refs.confirm.show({
                                title: "変更失敗",
                                message: "パスワードのリセットに失敗しました。<br/>"+e.data,
                                buttonYes: "戻る",
                                buttonNo: "",
                            })
                            return
                            break;
                    }
                }
                reset.onclose = function (e) {
                    console.log("onclose", e)
                }
                reset.onerror = function (e) {
                    console.log("onerror", e)
                    self.$refs.confirm.show({
                        title: "変更失敗",
                        message: "パスワードのリセットに失敗しました。",
                        buttonYes: "戻る",
                        buttonNo: "",
                    })
                    return
                }
            },
            /**
             * 指定された日時以降に登録されたユーザーを検索し、配列に格納
             */
            addUsers: function (dateTime) {
                console.log(dateTime)
                const self = this
                db.collection("users").where("registeredDateTime", "<", dateTime).orderBy("registeredDateTime", "desc").limit(10).get().then(function(snapShot){
                    snapShot.forEach(function(docUser){
                        self.users.push(docUser.data())
                    })
                })
            }
        }
    }
</script>
